/** @format */

import {CustomizedComponentProps} from '../types';

function CustomizedClipPath(props: CustomizedComponentProps) {
  const {width, height, offset} = props;
  const radius = 8;

  return (
    <defs>
      <clipPath id='rounded-plot-area'>
        <rect
          x={offset.left}
          y={offset.top}
          width={width - offset.left - offset.right}
          height={height - offset.top - offset.bottom}
          rx={radius}
          ry={radius}
        />
      </clipPath>
    </defs>
  );
}

export default CustomizedClipPath;

